import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getRooms, subscribeToRooms } from '../services/cloudflareService';
import { Room } from '../types';

export const useRoomsListSync = (hospitalId: string | undefined | null) => {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['rooms', hospitalId],
        queryFn: () => hospitalId ? getRooms(hospitalId) : [],
        enabled: !!hospitalId,
    });

    useEffect(() => {
        if (!hospitalId) return;

        const unsubscribe = subscribeToRooms(hospitalId, (updatedRooms) => {
            if (Array.isArray(updatedRooms)) {
                queryClient.setQueryData(['rooms', hospitalId], updatedRooms);
            }
        });

        return () => {
            unsubscribe();
        };
    }, [hospitalId, queryClient]);

    return query;
};
